import { Link } from "react-router-dom";
import { Globals as Oldglobals} from "../../global/Globals";
import { useNavigate } from 'react-router-dom';
import Header from "../../components/Header/Header";
import RaiseTicketNav from "../../components/Tickets/RaiseTicketNav";
import '../../pages/RaiseTicket/RaiseTicket.css'
import RadioButton from "../../components/RadioButton/RadioButton";
import { useState, useRef, useEffect, useCallback } from "react";
import TextArea from "../../components/TextArea/TextArea";
import FileUploader from "../../components/FileUploader/FileUploader";
import Button from '../../components/Button/Button';
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
import { fetchAllProposalsOrBriefsByProducerId, CreateTicket } from "../../services/api";
import PopUp from '../../components/PopUp/PopUp';
import { fetchByfilter } from "../../services/GenericAPI";
import Toast from "../../components/Toast/Toast";
import { useLanguage } from "../../context/Languagecontext";

export default function RaiseTicket(
    name,
    filterName,
    title,
    isDatePicker,
    onSelect,
    value,
    className,
    multiSelection = true,
){
    const navigate = useNavigate();
    const { Globals ,languages, setLanguages } = useLanguage();
    const NavLinkData= {FirstNavbar:Globals.TICKETS_PAGE.DASHBOARD,SecondNavbar:Globals.TICKETS_FILTER.TICKETS,ThirdNavbar:Globals.TICKETS_PAGE.RAISE_A_TICKET, Title:Globals.TICKETS_PAGE.RAISE_A_TICKET};
      const [isOpen, setIsOpen] = useState(false);
      const [selected, setSelected] = useState([]);
      const [options, setOptions] = useState([]);
      const [enableClearAll, setEnableClearAll] = useState(false);
      const dropdownRef = useRef(null);
      const [activeDropdown, setActiveDropdown] = useState(false);
      const [popupState, setPopupState] = useState(null);
      const [toast, setToast] = useState(null);
      const [isFileSelected, setFileSelected]=useState(null)
      const [dropdownState, setDropdownState] = useState({
          activeDropdown: null,
          dropdowns: {
            PROPOSAL: { options: [], selected: [], selectedText: [], isloading: false },
            BRIEF: { options: [], selected: [], selectedText: [], isloading: false },
            OTHER: { options: [], selected: [], selectedText: [], isloading: false },
          },
        });
      
        const dropdownRefs = useRef({}); // Store refs for dropdowns
      
        const prevSelectedState = useRef({});
        const [description, setDescription] = useState('');
        const [detailId, setDetailId] = useState('');
        const [proposalId, setProposalId] = useState('');
      const handleTextAreaChange = (data) => {setDescription(data)};
      const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };
  const [isValidated, setValidated] = useState(false);

  const handleToastClose = () => {
        setToast({ isOpen: false });
    };

  useEffect(() => {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "auto";
      };
    }, []);

    useEffect(() => {
      setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [], options:[] };
          return acc;
        }, {});
        return { ...prev, dropdowns: clearedDropdowns };
      });
      if(selectedType !== '') {
        fetchOptions(selectedType);
      }
    }, [languages]);
    useEffect(() => {
        let hasChanges = false;
        const hasSelectedOptions = Object.values(dropdownState?.dropdowns).some(
          (dropdown) => dropdown?.selected && dropdown?.selected.length >= 0
        );
        const hasselectedOptions = Object.values(dropdownState.dropdowns).some(
          (dropdown) => dropdown?.selected && dropdown.selected.length > 0
        );
    
        if (hasselectedOptions) {
          setEnableClearAll(true);
        } else {
          setEnableClearAll(false);
        }
    
        Object.keys(dropdownState.dropdowns).forEach((key) => {
          const currentSelected = dropdownState.dropdowns[key]?.selected;
          const prevSelected = prevSelectedState.current[key]?.selected;
    
          if (JSON.stringify(currentSelected) !== JSON.stringify(prevSelected)) {
            hasChanges = true;
            if (hasSelectedOptions) {
              const data = {
                proposal: dropdownState.dropdowns.PROPOSAL.selected,
                brief: dropdownState.dropdowns.BRIEF.selected
              };
            }
          }
        });
    
        if (hasChanges) {
          prevSelectedState.current = { ...dropdownState.dropdowns }; // Update the reference with new selected values
        }
      }, [dropdownState]);

        useEffect(() => {
          const handleClickOutside = (event) => {
            // Check if the click is outside all dropdowns
            const isClickInsideDropdown = Object.values(dropdownRefs.current).some(
              (ref) => ref?.contains(event.target)
            );
            if (!isClickInsideDropdown) {
              setActiveDropdown(null);
            }
          };
      
          document.addEventListener("mousedown", handleClickOutside);
          return () => {
            document.removeEventListener("mousedown", handleClickOutside);
          };
        }, []);
    
    const [selectedType, setSelectedTicketOpt] = useState('');
     const raidoButtonSelection = (type, value) => {
        setSelectedTicketOpt(value);
        setDescription('');
        setDropdownState({activeDropdown: null,
          dropdowns: {
            PROPOSAL: { options: [], selected: [], selectedText: [], isloading: false },
            BRIEF: { options: [], selected: [], selectedText: [], isloading: false },
            OTHER: { options: [], selected: [], selectedText: [], isloading: false },
          },
        })
    };

    const handletog = async (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));

    if (dropdownState.dropdowns[dropdownName].options.length === 0) {
      await fetchOptions(dropdownName);
    }
  };

  const handleFileUploadControls=(file)=>{
        setFileSelected(file);
    }
const [responseobj, setResponseObj] = useState({});
  const fetchOptions = async (dropdownName) => {
    console.log("dropdownname===>",dropdownName);
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: true },
        },
      }));
  
      try {
        if(dropdownName === 'OTHER' || dropdownName === 'Other'){
            const response = await fetchByfilter(
                    Oldglobals.FILTER_OPTIONS_NAME.OTHER_TICKET_CATEGORIES
                  );
                  const data = response.data.content;
                  const filterData = data[Oldglobals.FILTER_OPTIONS_NAME.OTHER_TICKET_CATEGORIES];
                  setResponseObj(data);
                  // Simulate fetching options for each dropdown
                  setDropdownState((prev) => ({
                    ...prev,
                    dropdowns: {
                      ...prev.dropdowns,
                      [dropdownName]: {
                        ...prev.dropdowns[dropdownName],
                        options: [...filterData],
                        isLoading: false,
                      },
                    },
                  }));
        } else {
            const response = await fetchAllProposalsOrBriefsByProducerId(
            selectedType
            );
            const data = response.data.content;
            setResponseObj(data);
            const filterData = data;
            // Simulate fetching options for each dropdown
            setDropdownState((prev) => ({
            ...prev,
            dropdowns: {
                ...prev.dropdowns,
                [dropdownName]: {
                ...prev.dropdowns[dropdownName],
                options: [...filterData],
                isLoading: false,
                },
            },
            }));
        }
      } catch (error) {
        console.error("Error fetching options:", error);
        setDropdownState((prev) => ({
          ...prev,
          dropdowns: {
            ...prev.dropdowns,
            [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: false },
          },
        }));
      }
    };

      const handleSelectAll = (dropdownName, selectAll, options) => {
    const selectedDataString = options.map((option) => String(option.id));
    const selectedDataText = options.map((option) => String(option.name));

    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: {
          ...prev.dropdowns[dropdownName],
          selected: selectAll ? selectedDataString : [],
          selectedText: selectAll ? selectedDataText : [],
        },
      },
    }));
  };

  const handleSelect = (dropdownName, value,singleSelect = false) => {
    setDropdownState((prev) => {
      const dropdown = prev.dropdowns[dropdownName];
      if (!dropdown) return prev;

      const idStr = value.id;
    const nameStr = value.name;

    
    let newSelected = [];
    let newSelectedText = [];
    if (singleSelect) {
      // Replace existing with just the selected value
     const isAlreadySelected = dropdown.selected.includes(idStr);
      newSelected = isAlreadySelected ? [] : [idStr];
      newSelectedText = isAlreadySelected ? [] : [nameStr];
      setProposalId(newSelected[0]);
      const matchedItem = selectedType === 'Proposal' || selectedType === 'Brief' ? responseobj.find(item => item.id.toString() === newSelected[0]?.toString()): '';
      setDetailId(matchedItem ? matchedItem.detailId : '');
    } else {
      const isSelected = dropdown.selected.includes(String(value.id));
      const inSelectedText = dropdown.selectedText.includes(String(value.name));

      newSelected = isSelected
        ? dropdown.selected.filter((item) => item !== String(value.id)).map(String)
        : [...dropdown.selected.filter((item) => item !== String(value.id)), String(value.id)];

      newSelectedText = inSelectedText
        ? dropdown.selectedText.filter((item) => item !== String(value.name)).map(String)
        : [
            ...dropdown.selectedText.filter((item) => item !== String(value.name)),
            String(value.name),
          ];
        }
      return {
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...dropdown,
            selected: newSelected,
            selectedText: newSelectedText,
          },
        },
      };
    });
  };

  const handleClearAll = () => {
    if (enableClearAll) {
      setEnableClearAll(false);
      setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [] };
          return acc;
        }, {});
        return { ...prev, dropdowns: clearedDropdowns };
      });
    }
  };


 const handleButtonClick = useCallback(
     (type) => {
        if (type === "submit") {
            setPopupState("submit");
        } else {
            setPopupState(type);
        }
     },
     []
   );

   const resetStates = useCallback(() => {
           setPopupState(null);
       }, []);


   const handleBack = useCallback(() => {
           if (popupState === "submit" || popupState === "Retry") {
               submitData();
           } else {
               navigate(Oldglobals.NAVPATH.TICKETS, { state: { activeHeader: "dashboard" } });
           }
       }, [navigate, popupState]);

       const showPopup = useCallback(
           (title, message, button1) => (
               <PopUp
                   title={title}
                   text={message}
                   normalAction={popupState !== "cross" ? handleBack : null}
                   normalActionText={popupState !== "cross" ? button1 : ""}
                   negativeAction={popupState === "cross" ? handleBack : null}
                   negativeActionText={popupState === "cross" ? button1 : ""}
                   popupType="abort"
                   onClose={resetStates}
                   buttonBGColor={popupState !== "cross" ? "#004894" : ""}
               />
           ),
           [handleBack, resetStates, popupState]
       );

           const submitData = () => {
               let requestBody = {
                ticketType: selectedType === 'Proposal' ? Oldglobals.TICKET_TYPE.PROPOSAL : selectedType === 'Brief' ?  Oldglobals.TICKET_TYPE.BRIEF : Oldglobals.TICKET_TYPE.OTHER,
                ticketDetails: description || "",
                proposalId: (selectedType === 'Proposal' || selectedType === 'Brief') ? proposalId : null,
                proposalDetailId: selectedType === 'Proposal' ? detailId : 0,
                category: selectedType === 'Other' ? dropdownState.dropdowns.OTHER.selected[0] : 0,
                referenceDoc: isFileSelected
               }
               CreateTicket(requestBody)
                   .then((response) => {
                       if (response.data.status === "OK") {
                           setPopupState(null);
                           navigate(Oldglobals.NAVPATH.TICKETS, { state: { toastValue: Globals.RAISE_TICKET.SUBMIT_BTN_TOAST_SUCCESS_MSG} });
                       } else {
                           navigate(Oldglobals.NAVPATH.TICKETS, { state: { toastValue: Globals.TOAST_FAILURE} });
                       }
                   }).catch(() => {
                       setPopupState("Retry");
                   });
       
       
           }
           useEffect(() => {
            if (selectedType && (dropdownState.dropdowns.PROPOSAL.selected.length > 0 || dropdownState.dropdowns.BRIEF.selected.length > 0 || dropdownState.dropdowns.OTHER.selected.length > 0) && description.length > 0){
                setValidated(true);
            } else {
                setValidated(false);
            }
      
    }, [selectedType, dropdownState.dropdowns.PROPOSAL.selected, dropdownState.dropdowns.BRIEF.selected, dropdownState.dropdowns.OTHER.selected, description]);

return(
    <div className="dashboard">
        <div className="Background-Page">
            <Header route="Tickets"/>
            <div className="Main-ticket">
                <RaiseTicketNav props={NavLinkData} />
                <div className="note-text-raise-ticket">
                  {Globals.TICKETS_PAGE.TICKET_NOTE_TEXT.split('FAQ').map((part, index, arr) =>
                    index < arr.length - 1 ? (
                      <span key={index}>
                        {part}
                        <Link className="cursor" to={Globals.NAVPATH.FAQ}>FAQ</Link>
                      </span>
                    ) : (
                      <span key={index}>{part}</span>
                    )
                )}
                </div>
                <div className="tickets-details">
                    <div className="ticket-form">{Globals.TICKETS_PAGE.TICKET_TYPE}<span id="mandatory" class="mandatory">*</span></div>
                    <div className="brief-radio-group">
                        <RadioButton
                            name={Globals.TICKET_TYPE.TICKETS_TYPE}
                            value="1"
                            label={Globals.TICKET_TYPE.PROPOSAL}
                            onClick={() =>
                                raidoButtonSelection(1, Oldglobals.TICKET_TYPE.PROPOSAL)
                            }
                        />
                        <RadioButton
                            name={Globals.TICKET_TYPE.TICKETS_TYPE}
                            value="2"
                            label={Globals.TICKET_TYPE.BRIEF}
                            onClick={() =>
                                raidoButtonSelection(2, Oldglobals.TICKET_TYPE.BRIEF)
                            }
                        />
                        <RadioButton
                            name={Globals.TICKET_TYPE.TICKETS_TYPE}
                            value="3"
                            label={Globals.TICKET_TYPE.OTHER}
                            onClick={() =>
                                raidoButtonSelection(3, Oldglobals.TICKET_TYPE.OTHER)
                            }
                        />
                    </div>
                    {selectedType === Oldglobals.TICKET_TYPE.PROPOSAL && (
                        <div>
                            <div className="ticket-form margin-bottom-1">{Globals.TICKET_TYPE.PROPOSAL}<span id="mandatory" class="mandatory">*</span></div>
                            <CheckboxDropDown
                                    className = "proposalDropDown-content"
                                      fontColor={`${dropdownState.dropdowns.PROPOSAL.selected.length && `assign-dropdown-font-black`}`}
                                        isOpen={activeDropdown === "PROPOSAL"}
                                        options={dropdownState.dropdowns.PROPOSAL.options}
                                        onToggle={() => handletog("PROPOSAL")}
                                        onSelectAll={(selectAll, options) =>
                                          handleSelectAll("PROPOSAL", selectAll, options)
                                        }
                                        onSelect={(value) => {
                                          handleSelect("PROPOSAL", value, true);
                                        }}
                                        selectedValues={dropdownState.dropdowns.PROPOSAL.selected}
                                        title={Globals.TICKETS_PAGE.PROPOSAL_DROPDOWN_PLACEHOLDER}
                                        isDatePicker={false}
                                        dropdownRef={(el) => (dropdownRefs.current["PROPOSAL"] = el)}
                                        selectedItems={dropdownState.dropdowns.PROPOSAL.selectedText}
                                        isCreatedBy = {true}
                                        search={true}
                                        singleSelect={true}
                                        wordWrapLimit={100}
                                      />
                            <div className="ticket-form header-margin">{Globals.TICKETS_PAGE.DETAILS_OF_THE_TICKET}<span id="mandatory" class="mandatory">*</span></div>
                            <TextArea
                                placeHolder={Globals.TICKETS_DETAIL.TICKET_DETAILS_PLACEHOLDER}
                                textAreaInput={(value) =>
                                handleTextAreaChange(value)
                                }
                                className={`allp-reassign-dropdown-width-500 ${
                                  description ? "brief-text-area-selected" : ""
                                }`}
                            />
                            <div className="ticket-form margin-bottom-1">{Globals.TICKETS_PAGE.UPLOAD_REFERENCE_PLACEHOLDER}</div>
                            <FileUploader
                                onFileUpload={(file) => {handleFileUploadControls(file)}}
                                className="brief-apply3-file-wrapper raiseaticketupload"
                                isFromRegPage={false}
                            />
                        </div>
                    )}
                    {selectedType === Oldglobals.TICKET_TYPE.BRIEF && (
                        <div>
                            <div className="ticket-form margin-bottom-1">{Globals.TICKET_TYPE.BRIEF}<span id="mandatory" class="mandatory">*</span></div>
                            <CheckboxDropDown
                            className = "briefDropDown-content"
                            fontColor={`${dropdownState.dropdowns.BRIEF.selected.length && `assign-dropdown-font-black`}`}
                                        isOpen={activeDropdown === "BRIEF"}
                                        options={dropdownState.dropdowns.BRIEF.options}
                                        onToggle={() => handletog("BRIEF")}
                                        onSelectAll={(selectAll, options) =>
                                          handleSelectAll("BRIEF", selectAll, options)
                                        }
                                        onSelect={(value) => {
                                          handleSelect("BRIEF", value, true);
                                        }}
                                        selectedValues={dropdownState.dropdowns.BRIEF.selected}
                                        title={Globals.TICKETS_PAGE.BRIEF_DROPDOWN_PLACEHOLDER}
                                        isDatePicker={false}
                                        dropdownRef={(el) => (dropdownRefs.current["BRIEF"] = el)}
                                        selectedItems={dropdownState.dropdowns.BRIEF.selectedText}
                                        isCreatedBy = {true}
                                        search={true}
                                        singleSelect={true}
                                        wordWrapLimit={100}
                                      />
                            <div className="ticket-form header-margin">{Globals.TICKETS_PAGE.DETAILS_OF_THE_TICKET}<span id="mandatory" class="mandatory">*</span></div>
                            <TextArea
                                placeHolder={Globals.TICKETS_DETAIL.TICKET_DETAILS_PLACEHOLDER}
                                textAreaInput={(value) =>
                                handleTextAreaChange(value)
                                }
                                className={`allp-reassign-dropdown-width-500 ${
                                  description ? "brief-text-area-selected" : ""
                                }`}
                            />
                            <div className="ticket-form margin-bottom-1">{Globals.TICKETS_PAGE.UPLOAD_REFERENCE_PLACEHOLDER}</div>
                            <FileUploader
                                onFileUpload={(file) => {handleFileUploadControls(file)}}
                                className="brief-apply3-file-wrapper raiseaticketupload"
                                isFromRegPage={false}
                            />
                        </div>
                    )}
                    {selectedType === Oldglobals.TICKET_TYPE.OTHER && (
                        <div>
                            <div className="ticket-form margin-bottom-1">{Globals.TICKET_TYPE.OTHER_CATEGORY}<span id="mandatory" class="mandatory">*</span></div>
                            <CheckboxDropDown
                            className = "otherDropDown-content"
                            fontColor={`${dropdownState.dropdowns.OTHER.selected.length && `assign-dropdown-font-black`}`}
                                        isOpen={activeDropdown === "OTHER"}
                                        options={dropdownState.dropdowns.OTHER.options}
                                        onToggle={() => handletog("OTHER")}
                                        onSelectAll={(selectAll, options) =>
                                          handleSelectAll("OTHER", selectAll, options)
                                        }
                                        onSelect={(value) => {
                                          handleSelect("OTHER", value, true);
                                        }}
                                        selectedValues={dropdownState.dropdowns.OTHER.selected}
                                        title={Globals.TICKETS_PAGE.OTHER_DROPDOWN_PLACEHOLDER}
                                        dropdownRef={(el) => (dropdownRefs.current["OTHER"] = el)}
                                        selectedItems={dropdownState.dropdowns.OTHER.selectedText}
                                        isCreatedBy = {true}
                                        search={true}
                                        singleSelect={true}
                                        wordWrapLimit={100}
                                      />
                            <div className="ticket-form header-margin">{Globals.TICKETS_PAGE.DETAILS_OF_THE_TICKET}<span id="mandatory" class="mandatory">*</span></div>
                            <TextArea
                                placeHolder={Globals.TICKETS_DETAIL.TICKET_DETAILS_PLACEHOLDER}
                                textAreaInput={(value) =>
                                handleTextAreaChange(value)
                                }
                                className={`allp-reassign-dropdown-width-500 ${
                                  description ? "brief-text-area-selected" : ""
                                }`}
                            />
                            <div className="ticket-form margin-bottom-1">{Globals.TICKETS_PAGE.UPLOAD_REFERENCE_PLACEHOLDER}</div>
                            <FileUploader
                               onFileUpload={(file) => {handleFileUploadControls(file)}}
                                className="brief-apply3-file-wrapper raiseaticketupload"
                                isFromRegPage={false}
                            />
                        </div>
                    )}
                </div>
            </div>
            <div className="raise-ticket-Btn-Wrapper smevaluationpage">
            <div className="SM-Half-Page-Close-Apply">
                <button
                            className="brief-cancel-btn"
                            onClick={() => handleButtonClick("cross")}
                          >
                            {Globals.CLOSE}
                          </button>
                <Button
                    title={Globals.APPLY_BRIEF.SUBMIT_BUTTON}
                    id=""
                    disabled={!isValidated}
                    additionalStyle={ isValidated? "brief-create-btn" : "brief-create-btn-disabled"}
                    action={() => handleButtonClick("submit")}
                />
            </div>
        </div>
         {popupState &&
                        showPopup(
                          Globals.RAISE_TICKET.POPUP[popupState].TITLE,
                          Globals.RAISE_TICKET.POPUP[popupState].MESSAGE,
                          Globals.RAISE_TICKET.POPUP[popupState].BUTTON_TEXT
                        )}
        
                    {toast?.isOpen && (
                        <Toast
                            status={toast?.status}
                            onClose={handleToastClose}
                            title={toast?.title}
                        />
                    )}
        </div>
    </div>
)

}